import { cloneDeep } from "lodash";
import { MESSAGE_TYPE } from "../data/constants";


export const POSCodeMapping = {
  REST_ERR_INPUT_VALIDATION: {
    code: "REST_ERR_INPUT_VALIDATION",
    message: "",
    messagetype: MESSAGE_TYPE.error
  },
  REST_NO_VERIFIED_EMAIL: {
    code: "REST_NO_VERIFIED_EMAIL",
    message: "Your email address is not verified. Please contact your account administrator.",
    messagetype: MESSAGE_TYPE.error
  },
  REST_ERR_EXISTING_BATCH_RUNNING: {
    code: "REST_ERR_EXISTING_BATCH_RUNNING",
    message: ""
  },
  REST_ERR_EXISTING_BATCH_QUEUED: {
    code: "REST_ERR_EXISTING_BATCH_QUEUED",
    message: ""
  },


}

export const REST_ERR_DUPLICATE_TABLE_EXISTS = "REST_ERR_DUPLICATE_TABLE_EXISTS";
export const REST_ERR_TABLE_ALREADY_EXISTS = "REST_ERR_TABLE_ALREADY_EXISTS";
export const REST_ERR_RECORD_ALREADY_EXISTS = "REST_ERR_RECORD_ALREADY_EXISTS";
export const REST_ERR_BRANCH_CANNOT_BE_UPDATE ="REST_ERR_BRANCH_CANNOT_BE_UPDATE";
export const REST_ERR_TABLE_OCCUPIED = "REST_ERR_TABLE_OCCUPIED";

export const pos_errormap_without_label: any = {
  UNKNOWN:
    "Operation failed. Please retry after some time. If the problem persists, contact us with a screen shot at help.rista@dotpe.in",
  VALIDATION_FAILED: "Input Validation Failed",
  REST_ERR_INPUT_VALIDATION: "Input Validation Failed",
  DB_OPERATION_FAILED: "Database operation failed due to restrictions.",
  REST_AUTHENTICATION_FAILED:
    "Invalid PIN / user. Enter a valid PIN or contact your business manager/admin.",
  REST_LICENCES_RESTRICTED_BY_ROLE:
    "User can't be assigned to  given set of licences based on his role",
  REST_USER_EDIT_NOT_ALLOWED: "Edit of User is not allowed",
  REST_LICENCE_RESTRICTED_BY_ROLE:
    "Manager is Not permitted add/edit Admin User",
  RESTRICTED_BY_BRANCH:
    "Assignment of branches to the user is invalid. Contact your business Admin to make changes to the branch assignment for this user.",
  REST_USER_ALREADY_REGISTERED:
    "User ID has already been assigned to another user",
  CATEGORY_ALREADY_EXISTS: "Category with same name already exists",
  REST_DISCOUNT_ALREADY_EXISTS: "Discount with code already exists",
  INVALID_BRANCH_SELECTION: "Invalid Branch Selection during assign branch",
  LICENCE_BRANCH_RESTRICTED:
    "The licence requested can not be used to work on multi-branch business",
  LICENCE_SETTING_FALIED: "Licence Setting Failed",
  REST_LICENCE_OPERATION_FAILED:
    "Acquiring licence failed as the licence is not available.",
  OPTIONSET_ALREADY_EXISTS: "Option set with the same name already exists.",
  SALE_LINK_FAILED: "Sending Email/ SMS failed as the Sale does not exists",
  SALE_NOT_EXISTS: "The referenced Sale does not exist.",
  REST_SALE_NOT_EXISTS: "The referenced Sale does not exist.",
  TAXTYPE_ALREADY_EXISTS: "A tax type with the same name already exists.",
  MULTI_BRANCH_NOT_ALLOWED:
    "The licence acquired by user doesn't allow update to multiple branches",
  USER_DOES_NOT_EXIST: "Non Existant User chosen to set the pin",
  REST_DEVICE_ALREADY_REGISTERED: "Device Already registered",
  REST_DEVICE_LABEL_ALREADY_USED: "Device label is already in use.",
  REST_DR_FAILED_KEY_EXPIRED: "This Device Registration Key has expired.",
  REST_DR_FAILED_KEY_INVALID: "Invalid Device Registration Key.",
  REST_DR_FAILED_KEY_USED: "This Device Regisration Key is already used.",
  REST_DR_FAILED_KEY_LOCKED: "This Device Registration Key is locked.",
  REST_DR_FAILED_INVALID_USER: "Invalid User.",
  REST_DR_FAILED_INVALID_CREDENTIALS: "Invalid credentials.",
  REST_TAX_HAS_REFERENCES:
    "Can not delete tax jurisdiction as there are branches referring the tax jurisdiction",
  TAX_TYPE_HAS_REFERENCES:
    "Can not delete tax type as there are catalog items referring the tax type",
  MENU_ALREADY_EXISTS: "Menu with same name already exists",
  ORDER_IS_NOT_OPEN: "Order is not currently Open",
  UNAUTHENTICATED_USER: "User is not authenticated",
  IDLE_TIMEOUT: "Session Timedout, require credentials",
  UNAUTHORIZED_DEVICE:
    "This device is not registered to a business. Please contact your business administrator.",
  REST_BILL_NOT_EXISTS: "The requested bill does not exist.",
  REST_UNKNOWN:
    "Operation failed. Please retry after some time. If the problem persists, contact us with a screen shot at help.rista@dotpe.in",
  REST_EMAIL_REQUIRED: "Please enter your verified email address.",
  REST_EMAIL_INVALID:
    "This is not a verfied email address. Please enter your verified email address.",
  REST_CONTACT_MANAGER: "Contact Manager to reset the pin",
  REST_INVALID_DEVICE:
    "This device is not registered to a business. Please contact your business administrator.",
  REST_PRINTER_ALREADY_EXISTS: "Printer with this ip already exists",
  REST_PRINTER_HAS_REFERENCES:
    "Can not delete printer as there are references in ticket configuration",
  REST_USER_NOT_FOUND: "User/ User Details not found",
  REST_BRANCH_NOT_PERMITTED: "Requested Branch is Not permitted by this user",
  USER_NOT_PERMITTED: "User is Not permitted to perform this action",
  INVOICE_CREATION_FAILED: "Creation of Renewal Invoice is failed",
  PAYMENT_VALIDATION_FAILED: "Payment Validation Failed",
  REST_SALE_WITH_NO_BALANCE:
    "No balance exists for Sale, Hence no update to payments allowed",
  ITEM_LICENCE_LIMIT_EXCEEDED:
    "The limit on # of catalog items for free licence is reached",
  REST_TRANSACTION_LICENCE_LIMIT_EXCEEDED:
    "The limit on # of sale transactions for free licence is reached",
  REST_SALE_NOT_OPEN: "Sale is not open, hence can not be cancelled.",
  REST_SALE_ACCEPT_PAYMENT_PENDING:
    "Payment in under process, check agains after few minutes",
  REST_SALE_ACCEPT_PENDING_BALANCE:
    "Can not accept the order as there is a balance due",
  REST_SALE_ACCEPT_PAYMENT_FAILED:
    "Can not accept the order as the payment by customer failed",
  SALE_DELETE_NOT_ALLOWED: "Delete of Sale is not permitted by user role",
  REST_DELIVERY_LABEL_NOT_ALLOWED:
    "Delivery Labels are not allowed for Rista Business",
  REST_BUSINESS_CONTACT_ROLE_RESTRICTION:
    "Busines contact can be of only Admin role",
  REST_BUSINESS_CONTACT_EMAIL_REQUIRED:
    "Email is required for business contact",
  REST_USER_EMAIL_REQUIRED: "Email is required for user",
  REST_BUSINESS_CONTACT_SHOULD_ACTIVE:
    "Business Contact should be in Active state",
  BUSINESS_CONTACT_EMAIL_NOT_VERIFIED:
    "User without verified email can not be business contact",
  BUSINESS_PRIMARY_CONTACT_REQUIRED: "Primary contact of business is required.",
  INVALID_PRIMARY_CONTACT:
    "The primary contact specified for business is not valid",
  INVALID_ALTERNATE_CONTACT:
    "The alternate contact specified for business is not valid",
  VERIFY_EMAIL_FAILED:
    "Sending verification mail on create/edit of user with email is failed",
  REST_BRANCH_NOT_FOUND: "Branch Not Found",
  REST_BRANCH_GROUP_MISSING_CHANNELS:
    "New Price Book doesn't have channel(s) currently being used by current Price Book",
  REST_RENEWAL_LICENCE_ADD_NOT_ALLOWED:
    "Addition of New Items to renewal order is not allowed",
  REST_RENEWAL_QUANTITY_INCREASE_NOT_ALLOWED:
    "Increase of Quantity not allowed for renewal licence",
  REST_LICENCE_INVALID_SKU_CODE:
    "The SKU provided for licence in the order is not valid",
  REST_BELONGS_TO_DIFFERENT_RISTA_BUSINESS:
    "The Rista customer selected doesn't belong to this Rista business (based on the customer country)",
  REST_ORDER_IS_NOT_OPEN:
    "The Licence order is not found or currently not open",
  REST_ERR_INVALID_INPUT: "Invalid input. Please check the values entered.",
  REST_RECORD_ALREADY_EXISTS: "Duplicates not allowed.",
  REST_VERSION_MISMATCH:
    "Updated by different user, reload for latest version.",
  REST_CHARGE_HAS_REFERENCES: "Charges has references in channel.",
  REST_LICENCE_ROLE_RESTRICTED:
    "This licence cannot be aquired by the current user because of role restrictions.",

  ITEM_HAS_REFERENCES:
    "Item currently used in inventory, hence cannot be deleted",
  LICENCE_ORDER_PREPARATION_FAILED: "Licence order preparation failed.",
  REST_LICENCE_ORDER_PREPARATION_FAILED: "Licence order preparation failed.",
  LICENCE_ORDER_VALIDATION_FAILED: "Licence order validation failed.",
  REST_LICENCE_ORDER_VALIDATION_FAILED: "Licence order validation failed.",
  RETURN_NOT_ALLOWED: "Return can only be performed on closed sales.",
  REST_IMAGE_UPDATE_FAILED: "Image update failed.",
  REST_IMAGE_NOT_FOUND: "Image not found.",
  REST_DELETE_FAILED: "Could not delete the image.",
  REST_STALE_CLIENT_VERSION:
    "Cannot login as this version of the app is no longer supported. Please update the app to the latest version.",
  REST_CUSTOMER_INFO_NOT_PRESENT: "No customer attached to sale.",
  UI_ERR_CUSTOMER_NOT_FOUND: "Customer not found",
  // "IMAGE_BULK_UPLOAD_DONE": '* images uploaded successfully. Images will take few minutes reflect on app.',
  REST_ERR_WA_TEMPLATE_NOT_CONFIGURED: "WhatsApp Template not configured",

  // Bulk Upload Option sets
  REST_VALIDATION_ERROR: "Validation Error",

  //Sale Validation Errors
  NO_ITEMS_PRESENT: "Order is presented without any items in it.",
  ITEM_VALIDATION_ERROR:
    "Item(s) has certain errors. Please review the items flagged.",
  ITEM_NOT_PRESENT: "The item is not present in catalog",
  ITEM_NOT_ACTIVE: "The item is currently not active",
  ITEM_NOT_FOUND_IN_BRANCH:
    "Item present in catalog, but price not found for this branch",
  ITEM_NOT_FOUND_IN_CHANNEL:
    "This item is not available for sale in the current channel",
  ITEM_INSUFFICIENT_RETURN_QUANTITY:
    "The requested quantity for return is more than the returnable quantity for this item.",
  ITEM_DISCOUNT_NOT_ALLOWED: "Discounts are not allowed on this item.",
  OPTION_VALIDATION_ERROR:
    "The selected options have error(s). Please review the options flagged.",
  DISCOUNT_VALIDATION_ERROR:
    "The selected discounts have error(s). Please review the discounts flagged.",
  CHARGE_VALIDATION_ERROR:
    "The selected charges have error(s). Please review the charges flagged.",
  MANDATORY_CHARGE_NOT_PRESENT:
    "Mandatory charges are not included with this sale",
  OPTION_NOT_PRESENT: "This option is currently not present in catalog",
  OPTION_NOT_FOUND_IN_BRANCH:
    "Option is present with catalog, but not defined for this branch or channel",
  OPTION_MAX_QTY_EXCEEDED: "Option maximum quantity has been exceeded.",
  DISCOUNT_NOT_PRESENT: "This discount is currently not present in catalog",
  DISCOUNT_EXPIRED:
    "This discount is not valid now, either expired or not started yet",
  DISCOUNT_OVERRIDE_NOT_ALLOWED:
    "Override of this discount is not allowed as per the discount definition",
  DISCOUNT_OVERRIDE_NOT_ALLOWED_BY_USER:
    "Discount override is not allowed by User role",
  DISCOUNT_NOT_FOUND_IN_BRANCH:
    "Discount is present in catalog, but not defined for this branch",
  CHARGE_NOT_PRESENT: "This charge is not present in catalog",
  CHARGE_NOT_FOUND_IN_BRANCH:
    "Charge present in catalog, but not defined for this branch",
  DISCOUNT_CATEGORY_NOT_APPLICABLE: "Discount not applicable.",
  ITEM_MIN_OPTIONS_ERROR: "Minimum required options not selected.",
  REST_INVENTORY_ORDER_ALREADY_PROCESSED:
    "This order has already been processed.",
  INSUFFICIENT_STOCK: "Out of stock",
  REST_SALE_BACK_ITEMS_NOT_PROCESSED:
    "This sale contains back ordered items. Please mark the sale processed to proceed.",
  REST_SALE_ITEMS_ON_HOLD:
    "This sale contains some items on hold. Please remove hold to proceed.",
  UI_ERR_NOT_PERMITTED: "User is not permitted to perform this action.",
  UI_ERR_DISTANCE_TOO_LONG: "Too far from location",
  UI_ERR_NO_GEOLOCATION: "No geolocation provided.",

  //Sale Validation Warnings
  ITEM_VALIDATION_WARNING:
    "Item(s) has certain warnings. Please review the items flagged.",
  ITEM_PRICE_DIFFERENT:
    "The item price was different than in catalog. Has been replaced with the catalog price.",
  OPTION_VALIDATION_WARNING:
    "The selected options have warning(s). Please review the options flagged.",
  DISCOUNT_VALIDATION_WARNING:
    "The selected discounts have warning(s). Please review the discounts flagged.",
  CHARGE_VALIDATION_WARNING:
    "The selected charges have warning(s). Please review the charges flagged.",
  OPTION_PRICE_DIFFERENT:
    "The option price was different than in catalog. Has been replaced with the catalog price.",
  DISCOUNT_PRICE_DIFFERENT:
    "The discount price was different than in catalog. Has been replaced with the catalog price.",
  DISCOUNT_TYPE_DIFFERENT:
    "The discount type (absolute/percentage) was different in catalog. Has been replaced with the type defined in the catalog.",
  DISCOUNT_CODE_CHANGED:
    "The discount code was different than in catalog. Has been replaced with the code defined in the catalog.",
  REST_SALE_HAS_LOYALTY_REDEMPTIONS:
    "Cannot apply discount as the sale has loyalty redemptions",
  // 'REST_REDEMPTION_LIMIT_EXCEEDED': 'Maximum loyalty redemption limit of * exceeded.',
  CHARGE_NAME_CHANGED:
    "The charge name was different in catalog. Has been replaced with the charge name defined in the catalog.",
  CHARGE_TYPE_CHANGED:
    "The charge type (absolute/percentage) was different than in catalog. Has been replaced with the charge type defined in the catalog.",
  CHARGE_PRICE_DIFFERENT:
    "The charge price was different than in catalog. Has been replaced with price in catalog.",
  REST_SALE_lOCKED: "This sale is locked and cannot be edited right now.",
  REST_DELIVERY_CONTACT_NOT_PRESENT: "No delivery contact present.",

  //UI only
  UI_NO_INTERNET_ERR: "No internet connection. Please check and try again.",
  UI_UNEXPECTED_ERR:
    "An unexpected error occured. This could be because of a network failure.",
  UI_MSG_PIN_RESET_SUCCESS:
    "An email has been sent to you. Please follow instructions in the email to reset your PIN.",
  UI_MSG_NO_NOTIFICATIONS: "No notifications at this time!",
  UI_TEMP_NETWORK_ERR: "Server not reachable. Please retry after some time.",
  REST_BUSINESS_NOT_ACTIVE: "Business currently not Active",
  REST_ACCOUNT_NOT_FOUND: "Account Number not found",
  UI_ERR_LOAD_GOOGLEMAPS:
    "There was an error loading maps. Please check your internet connection.",
  UI_MSG_DATA_LOAD_RETRY:
    "The application data could not be loaded. Check your internet connection and try again.",
  UI_BILL_DISPLAY_ERR: "Unable to render the bill.",
  UI_MSG_FETCHING_LOCATION: "Fetching current location",
  UI_ERR_FETCHING_LOCATION:
    "Could not fetch location. Please make sure your location settings are on.",
  UI_ERR_TICKET_SERVER_COMM_FAILED:
    "Ticket printing failed as sale could not be sent to local server.",
  UI_ACC_REMINDER_SUCCESS:
    "Reminder email will be sent if there is any payment due",
  UI_ACC_REMINDER_CUST_REQ: "Select customer to be reminded for payment.",
  // 'UI_ERR_ALREADY_EXISTS': 'This * already exists.',

  //Licence
  REST_LICENCE_MULTI_BRANCH_RESTRICTION:
    "Multi-Branch businesses cannot buy Licences applicable for Single Branch",
  REST_LICENCE_ADDON_RESTRICTION: "Add-on license requires the base license.",
  REST_LICENCE_COUNT_RESTRICTION:
    "The licence included in this sale exceeds the limit on number of such licences.",

  //Warnings:
  LATEST_CLIENT_VERSION_AVAILABLE:
    "New version of the app is available. Please download.",

  //Reservations:
  REST_RESOURCE_NOT_EXISTS: "This resource does not exist.",
  REST_RESOURCE_NOT_ACTIVE: "This resource is not active.",
  REST_INVALID_RESERVATION: "This appointment is invalid.",
  REST_RESERVATION_SETTINGS_NOT_EXIST:
    "Appointment Settings do not exist. Please define appointment settings before creating an appointment.",
  REST_RESERVATION_NO_SLOTS: "No slots available.",
  REST_RESERVATION_NON_BUSINESS_HOURS:
    "This appointment falls outside the business hours / resource hours.",
  REST_RESERVATION_NO_CAPACITY:
    "Please note that this appointment has exceeded the defined capacity.",
  // 'UI_MSG_RESOURCE_SCHEDULE': 'View your appointment schedule from * at *',
  UI_ERR_RESOURCE_NO_EMAIL_PHONE:
    "Please add a phone or email to the resource.",
  REST_RESOURCEGROUP_HAS_REFERNCES:
    "Can not delete resource group as there are references in resource or service.",

  //Upload customer:
  REST_FIRST_NAME_COLUMN_REQUIRED:
    "Uploaded file does not cotain first name header.",
  REST_UNEXPECTED_HEADERS:
    "Uploaded file contains headers which are not expected.",
  REST_UPLOAD_NO_HEADERS: "Headers not present in the file.",
  REST_UPLOAD_NO_RECORDS: "There are no records in the file.",
  REST_UPLOAD_NO_VALID_RECORDS: "There are no valid records in the file",
  // 'REST_UPLOAD_VALIDATION_ERROR': 'Errors found in the file uploaded. You will receive an email at * with details.',
  REST_NO_VERIFIED_EMAIL:
    "Your email address is not verified. Please contact your account administrator.",
  REST_ERR_INVALID_QR: "Invalid QR code.",
  // 'REST_INSUFFICIENT_PREPAID_BALANCE': 'Prepaid balance of * * is not sufficient to make this payment.',
  REST_ERR_LOYALTY_SCHEME_DOES_NOT_EXIST: "Loyalty scheme does not exist.",
  REST_ERR_BIZ_LOYALTY_SCHEME_INACTIVE:
    "Membership loyalty scheme is inactive.",
  REST_ERR_MEMBERSHIP_EXPIRED: "Customer membership is expired.",
  REST_ERR_MEMBERSHIP_DOES_NOT_EXIST: "Customer membership does not exist.",
  REST_LOYALTY_REDEEM_WITHOUT_CUSTOMER:
    "Loyalty points can be used only with a valid customer.",
  REST_MULTIPLE_LOYALTY_PAYMENTS:
    "Cannot process multiple loyalty payments at once.",
  REST_ERR_INSUFFICIENT_POINTS:
    "Loyalty Points available are not sufficient for redemption",
  REST_CUSTOMER_HAS_REFERENCES:
    "Cannot delete this customer because of some data references.",
  REST_CUSTOMER_EMAIL_UNIQUE: "There is a customer with provided email.",
  REST_CUSTOMER_PHONE_NUMBER_UNIQUE:
    "There is a customer with provided phone number.",
  REST_CANNOT_DELETE_LEVEL:
    "Cannot Delete Level Heirarchy because it attached to the item. Please the check CSV file",

  //Common UI errors
  // 'UI_CONFIRM_REMOVE': 'Do you want to remove this *?',
  // 'UI_VALIDATION_ERR_REQUIRED': '* is required.',
  // 'UI_VALIDATION_ERR_INVALID': '* is invalid.',
  // 'UI_VALIDATION_ERR_MIN_REQ': '* should have a minimum of * *.',
  // 'UI_VALIDATION_ERR_MAX_REQ': '* should be less than * *.',
  // 'UI_VALIDATION_ERR_UNIQUE': '* should be unique.',
  UI_OFFLINE_FEATURE_UNAVAILABLE: "This feature is not available offline.",
  UI_MSG_CONNECTIVITY_OFFLINE: "There seems to be a connectivity loss.",
  UI_MSG_GO_OFFLINE:
    'Go Offline? All your sales will be saved locally and will sync up the next time you go online. To go back online, go to the home view and select "Go Online" from the main menu.',
  UI_MSG_OFFLINE_NOT_AVAILABLE: "This module is not available offline.",
  UI_MSG_OFFLINE_PASSWD_INCORRECT:
    "This password is incorrect. Please try again.",
  UI_MSG_ENTER_OFFLINE_PASSWD: "Please enter an offline password.",
  UI_MSG_OFFLINE_PASSWD_VALIDATION: "Password must at least 6 characters long.",
  UI_MSG_NO_OFFLINE_USER_DATA:
    "No user data found. Please login to the system in online mode at least once.",
  UI_MSG_NO_OFFLINE_PASSWD:
    "No offline password exists. Please login using online mode and set an offline password to use this feature.",
  UI_MSG_SWITCHING_ONLINE: "Switching online as the local server is online",
  UI_MSG_SWITCHING_OFFLINE: "Switching offline as the local server is offline",
  UI_MSG_INTERNET_DISCONNECTED: "No internet connectivity.",
  UI_MSG_KILL_USER_SESSION: "Kill this user session and release the licence?",
  UI_MSG_LICENCE_UNAVAILABLE:
    "Licence unavailable. To view currently acquired licences, please click the red button in the list.",
  UI_MSG_EMAIL_INVITE_SENT: "Email invite sent to customer.",
  // 'UI_MSG_SMS_INVITE': '* is inviting you to download the Rista Market app for Android from * to place orders.',
  UI_MSG_SMS_SUCCESS: "SMS sent.",
  UI_MSG_CONFIRM_QR_RESET:
    "Sending a link / printing will result in reissuing a QR Code.",
  UI_MSG_CONFIRM_CUST_DELETE: "Are you sure you want to delete this customer?",
  UI_MSG_CONFIRM_CUSTOMER_EXPORT: "Export all customers?",
  UI_MSG_ITEM_NOT_FOUND: "Item not found.",
  UI_MSG_NO_CUSTOMER_FOR_PROFILE: "No customer to fetch profile.",
  // 'UI_MSG_CUSTOMER_ACCT_LINK_SMS': 'View your account with * at *.',
  UI_MSG_EMAIL_SUCCESS: "Email Sent",
  UI_MSG_FORMATTED_PRINTER_REQUIRED_FOR_QR:
    "QR Code can only be printed when printer content type is Formatted.",
  UI_MSG_FEATURE_UNAVAILABLE: "This feature is not available.",
  UI_MSG_TOO_MANY_FILES: "Too many files selected, please pick few.",
  UI_ERR_OFFLINE_DATA_EXISTS:
    "Offline data exists. Please go to PoS and sync data before logout.",
  // 'UI_ERR_RESTRICTED': '* is not allowed.',
  UI_MSG_PULL_DWN_REFRESH: "Pull to refresh the list.",
  NON_CONTIGUOUS_SELECTION_NA: "Non contiguous selection is not allowed.",
  UI_CNF_REPLACE_ADRS: "Replace the existing address?",
  UI_ERR_INV_MAP_CTR: "Address selection restricted to business country.",
  UI_CONFIRM_PO_TYPE:
    "Contract exists for Supplier.Please select the type of PO",
  UI_SELECT_CONTRACT_PO: "Please Select a Contract",
  UI_ERR_PO_CONTRACT_DATE_INVALID:
    "Contract is invalid for selected date. Please reselect Contract or change the backdate",

  //inventory backend errors
  REST_INVALID_PRODUCT_DEF: "Inventory item not found",
  REST_MATERIAL_HAS_REFERENCES:
    "Can not delete material as there are references in Inventory.",
  REST_MATERIAL_ALREADY_EXISTS: "Material with sku already exists.",
  REST_INVENTORY_ITEM_NOT_TRACKED: "Item does not have any activity.",
  REST_INVENTORY_ORDER_ALREADY_EXISTS: "Order already exists.",
  REST_SUPPLIER_HAS_REFERENCES:
    "Can not delete supplier as there are references to items and activivties in inventory.",
  // 'REST_SUPPLIER_INTERNAL_DUPLICATE': 'Following branches are served by supplier shown.*Please remove them before saving.',
  REST_SUPPLIER_NOT_PERMITTED_TO_ALL_BRANCHES:
    "Supplier is not permitted to all branches.",
  REST_SUPPLIER_NOT_PERMITTED_TO_SOME_BRANCHES:
    "Supplier permitted to only some branches.",
  REST_SUPPLIER_DELETE_NOT_ALLOWED: "Not permitted to delete this supplier.",
  REST_USER_NOT_PERMITTED_TO_BRANCH: "User not permitted to logged in branch.",
  REST_SUPPLIER_EDIT_NOT_ALLOWED: "Not permitted to update this supplier.",
  REST_SUPPLIERITEM_EDIT_NOT_ALLOWED:
    "Not permitted to update this supplier item",
  REST_SUPPLIERITEM_DELETE_NOT_ALLOWED:
    "Not permitted to delete this supplier item",
  REST_USED_IN_BOM:
    "Can not be changed, As it has been used as bill of materials.",
  REST_USED_IN_BOS:
    "Can not be changed, As it has been used as bill of supplies.",
  REST_HAS_MATERIALS: "Can not be changed, As it has bill of materials.",
  REST_INVENTORY_AUDIT_MISSING_ITEMS:
    "Scheduled items are not added for audit. Please add before updating.",
  REST_INVENTORY_AUDIT_EXTRA_ITEMS: "Audit has extra items than the scheduled.",
  REST_ERR_PROCURE_DUPLICATE_ORDERS_NOT_ALLOWED:
    "Duplicate orders for procure activity are not allowed.",
  REST_SUPLIERITEM_DUPLICATE_NAME: "Name already exists.",
  REST_SUPLIERITEM_DUPLICATE_SKU: "SKU code used for another supplier item.",
  REST_ACTIVITY_APPROVAL_NOT_REQUIRED:
    "Approval not required for this activity.",
  REST_INVENTORY_ORDER_ALREADY_APPROVED:
    "This activity has already been approved.",
  REST_FEATURE_RESTRICTED: "This feature is restricted.",
  REST_INVENTORY_ORDER_NOT_APPROVED: "This activity has not been approved.",
  REST_ACTIVITY_NO_ITEMS_TO_INCLUDE:
    "All the items have been considered. Please look at the related orders.",
  REST_SUPPLIER_EDIT_NOT_PERMITTED: "Editing supplier is not permitted.",
  REST_INVALID_ACTIVITY: "Invalid activity.",
  REST_INVENTORY_ORDER_CANCELLED: "This activity has been cancelled.",
  REST_ACTIVITY_NOT_FINAL: "This activity is not final.",
  REST_ACTIVITY_ALREADY_RESOLVED: "Activity has already been resolved.",
  REST_INVENTORY_ITEMS_DONOT_EXIST: "Inventory items does not exist.",
  REST_TRANSFER_OUT_INSUFFICIENT_STOCK:
    "Insufficient stocks for this order, Refer to current quantity for low stock items.",
  REST_TRANSFER_RETURN_OUT_INSUFFICIENT_STOCK:
    "Insufficient stocks for this order, Refer to current quantity for low stock items.",
  REST_ERR_EXPIRY_DATE_REQUIRED: "Perishable items require expiry date.",
  REST_ERR_BATCH_NUMBER_REQUIRED: "Perishable items require batch number",
  "REST_USED_AS_ALTERNATIVE ": "This has been used alternate item.",
  REST_INVENTORY_ORDER_ALREADY_RESOLVED:
    "This activity has already been resolved.",
  REST_BOTH_BOM_BOB_NOT_ALLOWED:
    "Inventory item can have either of bill of material or by-product.",
  REST_BOB_NOT_SUPPORTED:
    "Bill of By-Products not allowed for non stocked items",
  REST_BOS_NOT_SUPPORTED:
    "Bill of Supplies not allowed for non stocked materials",
  REST_BOM_NOT_SUPPORTED:
    "Bill of Materials not sllowed for non stocked supplies",
  REST_PRODUCTDEF_INVALID_MATERIALS:
    "BOM/BOB/BOS has referenced non existent item(s)",
  REST_NESTED_NON_STOCKED_SUPPLIES:
    "Non stocked supplies can not contain another Non stocked suppies in B0S",
  REST_NESTED_NON_STOCKED_MATERIALS:
    "Non stocked material can not contain antoher Non stocked item in BOM",
  REST_NESTED_NON_STOCKED_PRODUCTS:
    "Non stocked product can not contain antoher Non stocked product in BOM",
  REST_NON_STOCKED_BYPRODUCTS: "Non stocked item can not be part of BOB",
  REST_NON_STOCKED_ALT_ITEMS:
    "Non stocked item can not be configured as alternate item",
  REST_ALT_ITEMS_NOT_ALLOWED: "Alternate Items not allowed for this material",
  REST_DIRECT_BRANCH_TRANSFER_NOT_ALLOWED:
    "No supplier found. And direct transfer is restricted",
  REST_INVENTORY_ITEMS_NOT_VERIFIED:
    "Activites have unverifed items. Verify or remove the items to submit",
  REST_GRN_WITH_OUT_ATTACHMENTS: "GRN cannot be posted without attachments.",
  REST_BUSINESS_ACCESS_RESTRICTED:
    "Do not have permission to access this business",
  REST_ERR_SUPPLIER_REQUIRED: "Supplier missing",

  REST_MISSING_RECEIVER_TAX_ID: "Tax Id missing for the buyer.",
  REST_ERR_INVALID_EINVOICE_INPUT: "Invalid invoice details.",
  REST_MISSING_BUYER_TAX_ID:
    "Tax Id missing for the configured bill to branch.",
  REST_SELLER_STATE_CODE_MISMATCH:
    "Supplier address state code and GSTIN state code do not match.",
  REST_BUYER_STATE_CODE_MISMATCH:
    "Bill to branch state code and GSTIN state code do not match.",
  REST_RECEIVER_STATE_CODE_MISMATCH:
    "Buyer’s address state code and GSTIN state code do not match.",

  REST_ERR_INVALID_ACTIVITY_STATE:
    "EInvoice/Eway can be generated for finalised orders only.",
  REST_ERR_EINVOICE_ALREADY_EXISTS: "Active EInvoice already exists.",
  REST_CLEARTAX_GENERATE_EINV_ERROR: "EInvoice generation failed.",
  REST_ERR_EWAY_ALREADY_EXISTS: "Active Eway already exists.",
  REST_ERR_EWAY_ALREADY_IN_PROCESS:
    "Eway generation in progress. Please check back later.",
  REST_ERR_TRANSPORTER_INFO_NOT_PRESENT:
    "Transporter details missing. Please add them to proceed.",
  REST_ERR_INVALID_TRANSPORTER_INFO:
    "Invalid transporter details added. Please correct them to proceed.",
  REST_CLEARTAX_GENERATE_EWB_ERROR: "Eway generation failed.",

  REST_ERR_EINVOICE_DOESNT_EXIST: "EInvoice not found",
  REST_ERR_EINVOICE_ALREADY_CANCELLED: "EInvoice is already cancelled",
  REST_ERR_ACTIVE_EWAY_EXISTS:
    "Cannot cancel EInvoice. Active Eway exists against this IRN.",
  REST_ERR_EINVOICE_CANCEL_TIME_ELAPSED:
    "Cannot cancel EInvoice. The cancellation period has elapsed.",
  REST_CLEARTAX_CANCEL_EINV_ERROR: "Cancellation failed.",

  REST_ERR_EWB_DOESNT_EXIST: "Eway not found.",
  REST_ERR_EWAY_ALREADY_CANCELLED: "Eway is already cancelled.",
  REST_ERR_EWAY_CANCEL_TIME_ELAPSED:
    "Cannot cancel Eway. The cancellation period has elapsed.",
  REST_CLEARTAX_CANCEL_EWB_ERROR: "Cancellation failed.",
  REST_INVALID_SHIPPING_ADDRESS:
    "Incorrect Shipping address. Please make sure that the pincode, city, tax Id is configured correctly.",
  REST_INVALID_BUYER_ADDRESS:
    "Incorrect Buyer address. Please make sure that the pincode, city, tax Id is configured correctly.",
  REST_INVALID_SELLER_ADDRESS:
    "Incorrect Seller address. Please make sure that the pincode, city, tax Id is configured correctly.",
  REST_ITEMS_MISSING_INFO: "Items details are missing.",

  //KDS errors
  REST_TICKET_ALREADY_PROCESSED: "Ticket has already been processed.",

  //settings- backend errors
  ITEM_ALREADY_EXISTS: "Item with sku already exists.",
  RES_BRANCH_ALREADY_REGISTERED:
    "Branch with this branch code already registered.",
  REST_GROUP_HAS_REFERENCES:
    "Can not delete group as there are references to branches and prices.",
  REST_OPTIONSET_HAS_REFERENCES:
    "Can not delete option set as there are references to items.",
  REST_VARIANT_DUPLICATE_SKU_CODES: "SKU code used for another item",
  REST_ITEM_LICENCE_LIMIT_EXCEEDED:
    "Number of items exceeds items per license limit",
  REST_ITEM_HAS_REFERENCES:
    "Item can't be deleted as it is referenced elsewhere",
  REST_CHANNEL_HAS_REFERENCES:
    "Channel can't be deleted as it is referenced elsewhere",
  REST_CHANNEL_USED_IN_OPEN_ORDER:
    "Channel can't be deleted as it is referenced in Open Orders",
  REST_SALE_CHANNEL_NOT_PRESENT:
    "The channel assoiciated with this sale does not exist. Please pick another channel.",
  // 'REST_LICENCE_LIMIT_EXCEEDED': "You have exceeded your account limit of * by *",
  REST_ERR_DUPLICATE_MEASURING_UNITS: "Duplicate measuring units.",
  REST_PAYMENT_MODE_HAS_REFERENCES:
    "Can not delete or disable payment mode as there are references in branches.",
  REST_CATEGORY_HAS_REFERNCES:
    "Can not delete category as there are references in inventory groups or discount or charges.",
  REST_INVALID_CATEGORY: "Invalid Category",
  REST_INVALID_SUBCATEGORY: "Invalid Sub Category",
  REST_SUB_CATEGORY_REFERENCED_IN_ITEM:
    "Can not delete sub category as there are fererences in catalog items",
  REST_SUB_CATEGORY_REFERENCED_IN_DISPLYITEM:
    "Can not delete sub category as there are references in display book items",
  REST_CATEGORY_GROUP_HAS_REFERNCES:
    "Can not delete account as there are references in catalog item.",
  REST_DISCOUNT_REFERENCED_IN_MEMBERSHIP:
    "Can not delete discount as there are references in membership.",
  // 'REST_SALE_CUSTOMER_DISCOUNT_LIMIT_EXCEEDED': 'Exceeded the limits per customer for deal(s) *',
  // 'REST_SALE_CUSTOMER_DISCOUNT_LIMIT_PER_PERIOD_EXCEEDED': 'Exceeded the limits per customer in period for deal(s) *',
  // 'REST_SALE_BRANCH_DISCOUNT_LIMIT_EXCEEDED': 'Exceeded the limits per branch for deal(s) *',
  REST_TAX_REFERENCE_IN_TAX_AREA:
    "Tax can't be deleted as it is referenced in tax area.",
  REST_TAX_REFERENCE_IN_CHANNEL:
    "Tax can't be deleted as it is referenced in channel.",
  REST_TAX_REFERENCE_IN_CHARGE:
    "Tax can't be deleted as it is referenced in charge.",
  REST_TAX_REFERENCE_IN_ITEM:
    "Tax can't be deleted as it is referenced in item.",
  REST_MENU_REFERENCED_IN_CHANNEL:
    "Menu can't be deleted as it is referenced in channel.",
  REST_USER_INACTIVE: "User is inactive.",
  REST_SERVICE_NOT_MAPPED_TO_ITEM:
    "Please delete this service and create a new service reffering to a catalog item.",
  REST_SKU_ALREADY_PRESENT: "SKU code already exists.",
  REST_BILLSEQUENCE_UPDATE_NOT_ALLOWED: "Cannot update bill sequence.",
  REST_ERR_BILLSEQUENCE_HAS_REFERENCES:
    "Can not deactivate bill sequence as there are references in branches.",
  REST_BILLSEQUNCE_NOT_FOUND: "Bill sequence cannot be found.",
  REST_BILLSEQUNCE_UPDATE_FAILED: "Error in updating bill sequence.",
  REST_ACCESS_PROFILE_ROLE_CHANGED: "Change of role is not allowed.",
  REST_ACCESS_PROFILE_EDIT_NOT_ALLOWED: "Access profile cannot be editted.",
  REST_ACCESS_PROFILE_HAS_REFERENCES:
    "Access profile can't be deleted as it is referenced in user.",
  REST_BUSINESS_CONTACT_HAS_ACCESS_PROFILE:
    "Business contacts should not have profile.",
  REST_ROLE_ACCEESS_PROFILE_INVALID:
    "Selected access profile is invalid for the user role",
  REST_BUSINESS_CONTACT_EMAIL_NOT_VERIFIED: "User email is not verfied.",
  REST_USER_EDIT_ONLY_BY_CONTACT:
    "User can be edited only by business contact.",
  REST_BRANCH_LABEL_HAS_REFERENCES:
    "Branch label can't be deleted as it is referenced in branch.",
  REST_MEASURINGUNIT_IS_SAME: "Same measuring unit as previously selected.",
  REST_BRAND_HAS_REFERENCES:
    "Item brand can't be deleted as it is referenced in catalog items.",
  REST_BRANCH_NOT_CLOSED: "Branch is not closed.",
  REST_INVALID_ROYALTY_CONFIG: "Invalid franchisor.",
  REST_ERR_CURRENT_BRANCH_INACTIVE: "Current branch cannot be deactivate.",
  REST_ITEM_REFERENCED_IN_ROYALTY_CONFIG:
    "Item can't be deleted as it is referenced in franchisor royalty.",
  REST_CHANNEL_REFERENCED_IN_ROYALTY_CONFIG:
    "Channel can't be deleted as it is referenced in franchisor royalty",
  REST_INVALID_SOFTWAREFEE_CONFIG: "Invalid franchisor",
  REST_ITEM_REFERENCED_IN_SOFTWAREFEE_CONFIG:
    "Item can't be deleted as it is referenced in software fee config",
  REST_CHANNEL_REFERENCED_IN_SOFTWAREFEE_CONFIG:
    "Channel can't be deleted as it is referenced in software fee config",
  REST_CHANNEL_REFERENCE_IN_AGGREGATOR:
    "Sale channel can't be deleted, as it is referenced in Aggregator.",
  // 'REST_TRANSFER_OUT_PREPAID_BALANCE': "<p>Prepaid balance: *</p><p>Invoice amount: *</p><p></p><p>Would you like to use the prepaid balance?</p>",
  REST_CHANNELDEF_REFERENCE_IN_CHANNEL:
    "Sale channel can't be deleted as it is referenced in channel.",
  REST_CHANNELDEF_REFERENCE_IN_ITEMSCHEDULE:
    "Sale channel can't be deleted as it is referenced in Item Schedule",
  REST_CHANNELDEF_REFERENCE_IN_DISCOUNT:
    "Sale channel can't be deleted as it is referenced in deal.",
  REST_CHANNELDEF_REFERENCE_IN_MEMBERSHIP:
    "Sale channel can't be deleted as it is referenced in membership.",
  REST_CHANNELDEF_REFERENCE_IN_PRODUCTDEF:
    "Sale channel can't be deleted, as it is referenced in Inventory Items.",
  REST_CHANNELDEF_REFERENCE_IN_AGGREGATOR:
    "Sale channel can't be deleted, as it is referenced in Aggregator.",
  REST_CHANNELDEF_REFERENCE_IN_DISPLAYBOOK:
    "Sale channel can't be deleted, as it is referenced in Display Book",
  REST_INVALID_CHANNELDEF: "Invalid sale channel",
  REST_CHARGE_DUPLICATE_CONFIGURATION:
    "Duplicate reference of channels and branches defined in charge.",
  REST_CHARGE_USED_IN_ITEM:
    "Charge can't be deleted as it is referenced in item.",
  REST_CHANNELDEF_REFERENCE_IN_CHARGE:
    "Sale channel can`t be deleted as it is references in charge.",
  REST_SCHEDULE_REFERENCED_IN_ITEM:
    "Item schedule can`t be deleted as it is references in item.",
  REST_INVALID_ITEM_SCHEDULE: "Invalid item schedule.",
  REST_INVALID_ONLINE_LISTING: "Invalid online listing.",
  REST_INVALID_NOTIFICATION_RULE: "Invalid notification rule",
  REST_CHANNELDEF_HAS_REFERENCE_IN_ITEM:
    "Sale channel can`t be deleted as it is referenced in catalog items.",
  REST_CHANNELDEF_HAS_REFERENCE_IN_SUPPLIER:
    "Sale channel can`t be deleted as it is referenced in supplier.",
  REST_OPTIONSET_DUPLICATE_BRANCHES:
    "Optionset has duplicate variants with same combination branch and sale channel.",
  REST_DISPLAYBOOK_DUPLICATE:
    "Duplicate Display Configuration for One or More Branch - Channel combination",
  REST_INVALID_DISPLAYBOOK: "Invalid Display Book",
  REST_DISPLAYBOOK_UPLOAD_INVALID_SKUS:
    "One or more invalid SKU(s) in uploaded file",
  REST_BRAND_REFERENCE_IN_CHANNELDEF:
    "Brand can`t be deleted as it is references in sale channel.",
  REST_INVALID_BRAND: "Invalid Brand",
  REST_BRANCH_ALREADY_REGISTERED: "Branch already exists.",
  REST_ERR_BRAND_NOT_PRESENT_IN_PRICEBOOK:
    "Selected Brand(s) not configured for selected Price Book(s)",
  REST_BRANCH_INVALID_SPLITGROUPS: "Invalid split groups",

  //Upload Material :
  REST_NAME_COLUMN_REQUIRED: "Uploaded file does not contain name header.",
  REST_MEASURING_UNIT_COLUMN_REQUIRED:
    "Uploaded file does not contain measuring unit header.",
  REST_CATEGORY_COLUMN_REQUIRED:
    "Uploaded file does not contain category header.",

  //Upload BOM
  REST_RECORD_TYPE_COLUMN_REQUIRED: "Record type column is required.",
  REST_BOM_SKU_COLUMN_REQUIRED: "SKU column is required.",
  REST_YIELD_COLUMN_REQUIRED: "Yield column is required.",
  REST_BOM_DUPLICATE_MATERIAL: "Duplicate SKU in Bill of Materials",
  REST_BOS_DUPLICATE_MATERIAL: "Duplicate SKU in Bill of Supplies",
  REST_BOM_DUPLICATE_VARIANT:
    "Duplicate Bill of Materials Variant for one or more Branch/Channel combination",
  REST_BOB_DUPLICATE_VARIANT:
    "Duplicate Bill of By-Products Variant for one or more Branch/Channel combination",
  REST_BOS_DUPLICATE_VARIANT:
    "Duplicate Bill of Supplies Variant for one or more Branch/Channel combination",
  REST_BOM_CHANNEL_NOT_REQUIRED:
    "Channel not required in Bill of Materials variants",
  REST_BOB_CHANNEL_NOT_REQUIRED: "Channel not required in Bill of By-products",

  //Upload Catalog :
  REST_ITEM_NAME_COLUMN_REQUIRED:
    "Uploaded file does not contain item name header.",
  REST_PRICE_COLUMN_REQUIRED:
    "Uploaded file does not contain price name header.",
  // 'UI_MAIL_SENT': '* has been sent to *.',
  // 'UI_INTIM_UPLOAD_SUCC': 'The file is under process, result of processing will be emailed to *',

  //Help text.
  UI_MSG_HELP_SWIPE_PULL:
    "Swipe left for more options and pull down to refresh.",
  UI_MSG_HELP_SWIPE: "Swipe left for more options.",
  UI_ERR_SELECT_PRINTER_FROM_POS:
    "Please configure a printer for use from POS to use this feature.",

  //Bluetooth
  ERR_BLUETOOTH_NOT_SUPPORTED: "Bluetooth not supported on your device.",
  ERR_BLUETOOTH_NOT_ENABLED: "Please enable bluetooth.",
  ERR_BLUETOOTH_CONNECT_FAILED: "Cannot connect to bluetooth device.",
  ERR_BLUETOOTH_PLUGIN_INIT: "Please restart the app for bluetooth service.",
  ERR_BLUETOOTH_UNKNOWN: "An unknown error has occurred, please try again.",

  //USB
  ERR_USB_DEVICE_NOT_FOUND: "USB Device not found",
  ERR_USB_PERMISSION_DENIED: "USB permission denied",
  ERR_USB_UNSUPPORTED_DEVICE: "Unsupported USB device",
  ERR_PERMISSION_REQUIRED: "USB Permisssion required",
  ERR_UNKNOWN: "Unknown error",

  //Upload
  UI_CONFIRM_UPLOAD: "Do you want to upload the selected file?",
  REST_NO_PRICE_HEADERS: "Headers not present in the file.",
  REST_INVALID_PRICE_HEADERS:
    "Uploaded file contains headers which are not expected.",
  REST_SKU_COLUMN_REQUIRED: "SKU column is required.",
  REST_QUANTITY_COLUMN_REQUIRED: "Quantity column is required.",
  REST_UNIT_COST_COLUMN_REQUIRED: "Unit cost column is required.",
  REST_LABEL_COLUMN_REQUIRED: "Label column is required.",
  REST_MISSING_PRICE_HEADERS: "Uploaded file does not have price header.",
  REST_INVALID_CSV_FILE: "The uploaded file is not a valid .csv file.",

  //upload supplier
  REST_SUPPLIER_CODE_COLUMN_REQUIRED: "Supplier code column is required.",
  REST_SUPPLIER_NAME_COLUMN_REQUIRED: "Supplier name column is required.",

  //upload barcode labels
  REST_ERR_UNSUPPORTED_FILE_TYPE:
    "Barcode template file type is not supported.",
  REST_ERR_FILE_TOO_LARGE: "Barcode template file is too large.",
  REST_ERR_FILE_EMPTY: "Barcode template file is empty.",

  //Void Sale Errors
  REST_SALE_NOT_CLOSED: "Cannot Void the sale as it is not closed.",
  REST_VOID_NOT_ALLOWED_ON_RETURNS: "Return cannot be voided.",
  REST_RETURN_NOT_ALLOWED_ON_VOIDED: "Return is not allowed on Voided Sales.",

  //Authentication errors
  REST_INSUFFICIENT_INFORMATION:
    "Device not valid or user Id / pin is missing.",
  REST_INACTIVE_OR_NON_EXISTANT_DEVICE: "This device is not active.",
  REST_DEVICE_NOT_FOUND:
    "This device is not registered to a business. Please contact your business administrator.",
  REST_INACTIVE_DEVICE:
    "This device has been inactivated. Please activate this device from another registered device.",
  REST_INVALID_BRANCH: "The branch associated with this device is not active.",
  REST_INVALID_USER: "This user is blocked.",
  REST_INVALID_BUSINESS: "This business is inactive.",
  REST_INVALID_CUSTOMER: "Invalid customer",
  REST_NOT_PERMITTED_ON_THIS_DEVICE:
    "Cannot be logged in as you do not have access to the branch associated with the device.",

  REST_ERR_FEEDBACK_CAMPAIGN_DOES_NOT_EXIST:
    "No feedback campaign exists for this channel. To define a feedback, go to the Marketing module.",
  REST_ERR_KIOSK_NO_ACTIVE_ORDER:
    "We did not find an active order, please try again later!",

  //inventory
  REST_INVENTORY_ORDER_ALREADY_DELETED: "Order has already been deleted.",
  REST_INVENTORY_ORDER_ALREADY_CANCELLED: "Order has already been cancelled",
  REST_INVENTORY_ORDER_IN_PROCESS: "Order is in process",
  REST_INVENTORY_ORDER_PARTIAL_SUBMIT: "Order has been partially submitted",
  REST_UNIT_USED_IN_BILL_OF_MATERIALS:
    "Measuring Unit has references in bill of materials.",
  REST_DUPLICATE_BILL_OF_MATERIALS:
    "Duplicate bill of materials are not allowed.",
  REST_ITEM_MANY_DEFAULT_SUPPLIERS:
    "Item should have only one default supplier.",
  REST_ITEM_NO_DEFAULT_SUPPLIERS: "Item has no default supplier.",
  REST_ITEM_DUPLICATE_INTERNAL_SUPPLIER: "Item has duplicate internal supplier",
  REST_INVENTORY_ORDER_CANCEL_NOT_ALLOWED:
    "Inventory order cancel not allowed.",
  REST_INVALID_SUPPLIER_ITEMS:
    "Price not found for few items. Please fix before proceeding.",
  REST_SUPPLIERTAX_HAS_REFERNCES:
    "Can not delete supplier tax as there are supplier item referring the tax",
  REST_SUPPLIER_TAX_REFERENCE_IN_CHARGE:
    "Can not delete as the tax as it is referenced in supplier charge",
  REST_BRANCHES_HAVE_SUPPLIER_RELATION:
    "Supplier catalogue is not applicable. Cancel the order and create again using supplier catalogue.",
  REST_BRANCHES_NO_SUPPLIER_RELATION:
    "Cancel the order and create again using inventory catalogue.",
  REST_BRANCHES_SUPPLIER_RELATION_CHANGED:
    "Supplier catalogue is changed. Cancel the order and create again with new supplier catalogue.",
  REST_EXTERNAL_SUPPLIER_NOT_ALLOWED:
    "Supplier catalogue is not available. Cancel the order and create again.",
  REST_INVALID_CHANNEL: "Invalid channel.",
  REST_ACTIVITY_DUPLICATE_SKU: "Duplicate SKU entries present in the activity.",
  REST_SUPPLIER_DUPLICATE_CATALOG_ITEM: "Catalog item already listed.",
  REST_INVALID_SUPPLIER: "Invalid supplier.",
  REST_PO_EXPIRY_DATE_PAST: "Expiry Date of Purchase Order is in Past",
  REST_ITEM_EXPIRY_QTY_ERROR:
    "Quantity in batches is mismatching with total quanity for few items. Please fix before proceeding.",
  REST_GRN_HIGHER_QUANTITY:
    "Quantity in batches is higher than PO for few items. Please fix before proceeding.",

  //barcode templates
  REST_ERR_ITEM_DOES_NOT_EXIST: "Item does not exists.",
  REST_ERR_INVALID_SCHEDULE_PRICE:
    "Schedule Price can not exist without a default price",

  //Settlements
  REST_BRANCHTXN_COLLECTIONS_MISMATCH:
    "This settlement has been updated and the view has been refreshed. Please review and Close again.",
  REST_BRANCHTXN_ALREADY_CLOSED: "This settlement is already closed.",
  REST_BRANCHTXN_SESSIONS_OPEN:
    "The user for this settlement needs to log out of all devices.",
  REST_SETTLEMENT_NOT_OPEN: "This settlement is not open.",
  REST_NO_OPEN_SETTLEMENT: "No settlement open.",
  REST_SETTLEMENT_DIFFERENT_USER:
    "This settlement does not belong to the selected user.",
  UI_MSG_CLOSE_SETTLEMENT: "Close this settlement?",
  UI_MSG_CLOSE_SETTLEMENT_BALANCE: "Close this settlement with balance?",
  SETTLEMENT_OPEN_ALREADY_RECORDED: "Settlement already open",
  REST_SETTLEMENT_OPEN_NOT_RECORDED: "An open settlement is not recorded yet.",
  REST_SETTLEMNT_SESSIONS_OPEN:
    "Please logout of all devices other than the current device to close settlement.",

  REST_TICKET_TRANSFER_TO_SAME_SALE:
    "Cannot transfer ticket to the same sale. Please select another sale.",
  REST_SUBTICKET_TRANSFER_NOT_ALLOWED: "Transfer of this ticket is not allowed",
  REST_DEVICE_NO_LABEL: "No label assigned to device",
  REST_DEVICE_HAS_REFERENCED_IN_TICKET_SETTINGS:
    "Cannot delete device as it is configured as ticket print device",
  // 'REST_SETTLEMENT_OPEN_ON_DEVICE': 'Cannot open as settlement for * is open on this device.',
  REST_SETTLEMENT_CANT_CLOSE_ON_DEVICE:
    "Cannot close settlement on this device.",
  REST_SETTLEMENT_NOT_CLOSED: "Settlement not closed",
  REST_INVALID_SETTLEMENT: "Invalid settlement",
  REST_SETTLEMENT_ALREADY_RESOLVED: "This settlement is already resolved",
  REST_SETTLEMNT_NOT_DUE: "No dues in settlement",
  UI_ERR_LOGOUT_FROM_POS:
    "Cash register open. Please navigate to Pos and logout.",
  REST_FROM_SALE_NOT_OPEN: "This sale is not open.",
  REST_SALE_OPERATION_NOT_ALLOWED: "Sale operation is not allowed.",
  REST_TRANSFER_OF_SPLIT_SALE_IS_NOT_ALLOWED:
    "Transfer of split sale is not allowed.",
  REST_NEW_RESOURCEID_CANNOT_BE_EQUAL_TO_OLD_RESOURCEID:
    "Cannot transfer to same table.",
  REST_INVALID_NEW_RESOURCEID: "Invalid table",
  REST_ERR_NEW_RESOURCE_NAME_NOT_PRESENT: "Table not found",
  REST_ERR_RESOURCE_OCCUPIED: "Table occupied",

  //TCP server start
  UI_SERVER_NOT_AVAILABLE:
    "This feature is not be available on this device at this moment.",
  ERR_SERVER_INVALID_INPUT:
    "Cannot connect to other devices, please contact support.",
  ERR_SERVER_NO_NETWORK_INTERFACES:
    "This feature cannot be enabled on this device.",
  ERR_SERVER_CREATE_FAILED:
    "An unknown temporary problem has occured, please try again.",
  ERR_SERVER_LISTEN_FAILED:
    "An unknown temporary problem has occured, please try again.",
  ERR_SERVER_NO_CLIENT_FOUND: "Cannot connect to client to send message.",
  ERR_SERVER_CLIENT_CONNECTION: "Cannot connect to local server.",
  ERR_SERVER_IO: "Local server not reachable.",
  //TCP server end

  //Printer errors
  // 'PRINT_UNSUCCESSFUL': '* could not be printed on *. Reason: ',
  ERR_IO: "Cannot connect to printer.",
  UI_ERR_SELECT_PRINTER: "Please select a printer to print.",
  ERR_INVALID_INPUT: "IP/port for printer not provided.",
  ERR_PRINT_TIMEOUT: "Print request timed out.",

  //Local server errors
  UI_MSG_MASTER_ONLINE:
    "Cannot perform this action as the server is online. Please go online.",
  UI_MSG_MASTER_OFFLINE:
    "Cannot perform this action as the server is offline. Please go offline.",
  REST_LOCAL_SERVER_NOT_LOGGED_OUT:
    "The designated branch server is not online. Please bring it online to  sync all sales.",
  // "RISTA_OFFLINE_WARN_MSG": "You have been offline for more than * hours. Please go online to sync offline data to server.",
  MANDATORY_FIELD_NOT_PRESENT: "A required field is missing.",

  //offline db errors
  ERR_OFFLINE_DB_DELETE: "Unable to clear data on this device.",
  ERR_OFFLINE_DB_SAVE:
    "Unable to write to this device, Please check available storage.",

  //add on errors
  UI_MSG_SMS_PROVIDER_NOT_CONF:
    "SMS provider not configured for your business.",
  UI_MSG_SMS_NO_PROVIDER: "No SMS provider available for your country.",
  REST_UNSUPPORTED_SMS_PROVIDER: "SMS provider is not supported.",
  REST_SMS_LOW_BALANCE:
    "Your SMS balance is low, recharge your SMS account to send SMS.",
  REST_SMS_DENIED: "Unable to send SMS to this number.",
  REST_SMS_CONFIG: "SMS send failed, check your SMS provider configuration.",
  UI_MSG_STORAGE_NO_PROVIDER: "No storage provider available for your country.",
  UI_MSG_NO_PROVIDER: "No provider available for your country.",
  REST_UNSUPPORTED_MARKETING_PROVIDER: "Provider not supported.",
  REST_UNSUPPORTED_STORAGE_PROVIDER: "Storage provider is not supported.",
  REST_STORAGE_INVALID_CREDENTIAL:
    "Cannot access storage provider with provided values.",
  REST_UNSUPPORTED_AGGREGATOR: "Aggregator is not supported.",
  REST_ERR_AGGREGATOR_BRANCH_CHANNEL_EXISTS:
    "Selected branch and channel already has aggregator configured.",
  REST_ERR_AGGREGATOR_BRANCH_EXISTS:
    "Selected branch already has provider configured.",
  REST_OUTLET_ID_TAKEN: "Outlet id is taken, please configure again!",

  //payment errors
  REST_CARD_DECLINED: "The card is declined.",
  REST_ERR_PAYMENT_CAPTURE:
    "Payment incomplete, please contact help.rista@dotpe.in",
  REST_ERR_PAYMENT_GATEWAY_AUTH:
    "Payment incomplete, please contact help.rista@dotpe.in",

  //package errors,
  REST_RECORD_ALREDAY_EXISTS: "Package already exists.",
  REST_INVALID_PKG: "Invalid package.",
  UI_VALIDATION_EMAIL_PHONE_REQD: "Either email or phone is required.",
  UI_MSG_TICKET_PRINT_FAILED: "Ticket printing failed.",

  REST_APP_UPGRADE_REQUIRED: "Please upgrade app to access this feature.",
  REST_USER_REPRINT_NOT_ALLOWED:
    "User role is not permitted to reprint a sale. Please contact manager.",

  //Audit
  REST_SALE_DELETE_NOT_CLOSED: "Sale not closed",
  REST_SALE_HAS_REFERENCES: "Sale has references",
  REST_SALE_DELETE_NOT_ON_WITH_BALANCE: "Sale has balance",

  REST_INVALID_COUPON_PROVIDER: "Coupon issuer is not valid.",
  REST_INVALID_COUPON: "Invalid coupon",
  REST_COUPON_EXPIRED: "This coupon has expired.",
  REST_COUPON_EXERCISED: "This coupon has already been exercised.",
  REST_COUPON_NOT_ACTIVE: "This coupon is not active.",
  REST_COUPON_INVALID_FOR_BRANCH: "This coupon is not valid for this branch.",
  REST_COUPON_INVALID_TIME: "This coupon is not valid currently",
  REST_COUPON_DISCOUNT_INVALID_TIME: "This coupon is not valid at this time.",

  //Sale updates:
  REST_INVALID_DISCOUNT_UPDATE: "Invalid discount update.",
  REST_SALE_ALREADY_CANCELLED: "This sale is already cancelled.",
  REST_SALE_ACCEPTED: "This sale is already accepted.",

  //DELIVERY PARTNER
  REST_DELIVERY_USER_INACTIVE: "Delivery user is inactive on partner platform.",
  REST_DELIVERY_USER_BUSY: "Delivery user is busy.",
  REST_DELIVERY_PARTNER_MAPPING_ISSUE:
    "Store is not mapped on delivery partner.",
  REST_DELIVERY_PARTNER_CONFIG_ISSUE:
    "Delivery partner configuration is not correct, please verify.",
  REST_DELIVERY_PARTNER_BUSY: "Delivery partner's system is busy.",
  REST_DELIVERY_PARTNER_UNKNOWN_ERROR:
    "Delivery partner could not accept the request, please try again later!",

  //Marketing errors
  REST_COUPON_ISSUER_COLUMN_REQUIRED:
    "Upload file does not have coupon issuer column.",
  REST_COUPON_CODE_COLUMN_REQUIRED:
    "Upload file does not have coupon code column.",
  REST_DISCOUNT_CODES_COLUMN_REQUIRED:
    "Upload file does not have discount codes column.",
  REST_EXPIRES_ON_COLUMN_REQUIRED:
    "Upload file does not have expires on column.",
  REST_VALID_FROM_COLUMN_REQUIRED:
    "Upload file does not have valid from column.",
  REST_CAMPAIGN_NAME_COLUMN_REQUIRED:
    "Upload file does not have campaign name column.",
  REST_ERR_PAST_COUPON_EXPIRY_DATE:
    "Can not publish campaign with past expiry date.",
  REST_SALE_ALREADY_HAS_DEALS:
    "Sale already has coupon deals, discounts update is not allowed.",
  REST_SALE_DEALS_NOT_ALLOWED: "Deals can not be applied on a old sale.",

  //Out of stock items msgs
  UI_MSG_OUT_OF_STOCK_UPDATE_SUCC:
    "Out of stock items have been synced successfully.",

  //Notification rules errors
  REST_ERR_TOO_MANY_NOTIFICATION_RULES: "Too many rules added for this event.",

  REST_ERR_DUPLICATE_REQ_COMPLETED: "Duplicate request.",
  REST_ERR_DUPLICATE_REQ: "Duplicate request, earlier request is in process.",

  //Sale Split

  REST_NO_SPLIT_GROUPS: "No split criteria defined",
  REST_SALE_INVALID_SPLIT_QUANTITY: "Invalid split quantity",
  REST_INVALID_ORIGINAL_SALE: "Invalid sale",
  REST_SALE_SPLIT_INVALID_STATUS: "Invalid status for split",
  REST_SALE_WITH_PAYMENTS_SPLIT: "Sale with payments cannot be split",
  REST_SALE_WITH_RETURNS_SPLIT: "Sale with returns cannot be split",
  REST_SALE_WITH_DISCOUNTS: "Sale with discounts cannot be split",

  REST_REPORT_MULTIPLE_BRANCHES_NOT_ALLOWED:
    "Multiple branch selection is not allowed for this report.",
  REST_REPORT_ONLY_ONE_MONTH_ALLOWED:
    "Only one month salection allowed for this report",

  //Payments
  REST_MULTIPLE_EXTERNAL_PAYMENTS:
    "Multiple payments cannot be performed at the same time.",
  REST_INVALID_EXTERNAL_PAYMENT: "Invalid payment provider",
  REST_INVALID_PAYMENT_AMOUNT: "Invalid payment amount",
  REST_WITHOUT_SPECIAL_PAYMENTS: "No external payments.",
  REST_MULTIPLE_SPECIAL_PAYMENTS_NOT_ALLOWED:
    "Multiple external payments not allowed. Remove and retry.",

  REST_BRANCH_ALREADY_CLOSED: "The branch is already closed.",
  REST_BUSINESS_DAY_CLOSED:
    "Cannot perform this action as this branch is currently closed for business. Please contact admin.",
  REST_BRANCH_CLOSE_SUCCESS: "Branch closed successfully.",
  REST_CANNOT_CLOSE_WITH_OPEN_ORDERS:
    "Branch cannot be closed with open orders.",
  REST_DISCOUNT_LOYALTY_NOT_EXISTS: "No loyalty redemption scheme found.",

  REST_EXTERNAL_SALE_CONTACT_OLDER:
    "You cannot contact the provider for an old sale.",
  REST_CHANNEL_DOES_NOT_EXIST: "Channel does not exist.",

  //Customer authentication
  REST_CUSTOMER_NOT_AUTHENTICATED: "Customer not authenticated",
  REST_CUSTOMER_WITHOUT_PHONE_NUMBER: "Customer does not have a phone number.",
  REST_NO_SMS_PROVIDER: "No sms provider configured.",

  //Offline Login
  UI_ERR_INVALID_LOGIN_PARAMS:
    "Login params not found. Please select user and enter a valid Pin",
  UI_ERR_OFFLINE_PASSWORD_NOT_FOUND: "Offline password not found for user",
  UI_ERR_LICENCE_NOT_PERMITTED:
    "User is not permitted to use the current licence",
  UI_ERR_MODULE_NOT_PERMITTED:
    "User is not permitted to use the current module",
  UI_ERR_USER_DATA_NOT_FOUND: "Offline user data not found.",
  UI_ERR_OFFLINE_USER_NOT_FOUND:
    "User not setup / found offline. Please contact admin or login online once to refresh.",
  OFFLINE_DB_NOT_AVAILABLE: "Offline DB not available.",
  // 'UI_ERR_MODULE_NOT_AVAILABLE': 'Module not available in selected licence, Last Used: *, Default: *',
  REST_SALE_WITH_STALE_CATALOG:
    "Amount mismatch. You might have a stale catalog. Please logout and login to refresh.",
  REST_INVALID_SALE: "Sale not found",

  REST_ERR_INVALID_PROCESS_STATE:
    "Cannot update sale to processed. Please verify the sale.",
  REST_ERR_SUPPORT_SUBMIT_FAILED: "Support request submit failed.",
  REST_CLIENT_CLOCK_WRONG:
    "Your system time or time zone seems to be incorrect. Please fix to proceed.",
  REST_PAYMENT_DAY_OVERRIDE_NOT_ALLOWED:
    "Payment day cannot be edited for this payment",
  UI_ERR_KB_ACTION_NA: "This keyboard action is not allowed.",
  REST_ERR_CUSTOMER_APPROVAL_NOT_CONFIGURED:
    "No users configured for customer approval.",
  REST_INVALID_NOTIFICATION_MESSAGE:
    "This notification message does not exist.",
  REST_INVALID_NOTIFICATION_ACTION: "Action not allowed on this message.",
  REST_ALREADY_APPROVED: "This request is already approved.",
  REST_ALREADY_REJECTED: "This request was previously rejected.",
  REST_APPROVAL_NOT_REQUIRED: "Approval not required",
  REST_ERR_PAYMENT_REFERRED_IN_ONLINE_LISTING:
    "Cannot remove payment as it is referred in online listing.",
  REST_ERR_DISCOUNT_LIMIT_EXCEEDED:
    "Manual discount is more than the permitted limits",
  REST_SALE_INVALID_APPROVAL_REQUEST: "Invalid Request Id to check the status",
  SENT_DIGITAL_BILL: 'Bill sent successfully over $ to $',

  REST_ERR_EXISTING_BATCH_QUEUED: "Your previous request is Queued, please wait for it to complete.",
  REST_ERR_EXISTING_BATCH_RUNNING: "Your previous request is In Progress, please wait for it to complete.",

  REST_MRP_VALUE_MISSING: "MRP is required for the selected Tax Applied On",
  REST_TAX_VALUE_MISSING: "Taxes required when Tax Applied On is selected",
  REST_PRICE_CANNOT_BE_INCLUSIVE_OF_TAX:
    "Price can not be inclusive of tax for the selected Tax Applied On",
  // Ewards integration
  REST_INVALID_LOYALTY_PROVIDER: "Loyalty provider is not configured",
  REST_LOYALTY_INVALID_ENDPOINT: "Loyalty proivder is not configured",
  REST_EWARDS_REDEEM_ERROR: "Loyalty redemption failed",
  REST_EWARDS_REDEEM_VERIFY_ERROR: "Loyalty Verification failed",
  REST_COUPON_PHONE_REQURIRED: "Phone number required to redeem coupon",
  REST_EWARDS_COUPON_VERIFY_ERROR: "Coupon verification failed",
  REST_LOYALTY_REDEEM_ERROR: "Loyalty redemption failed",
  REST_LOYALTY_REDEEM_VERIFY_ERROR: "Loyalty Verification failed",
  REST_INVALID_COUPON_DISCOUNT: "Coupon has no discounts",
  REST_COUPON_WITH_NON_COUPON_DEALS:
    "Coupon can not be mapped to non coupon deals",
  REST_COUPON_WITH_MIXED_VOCUHER_DEALS:
    "Coupon can not have mix of voucher deals with other type of deals",
  UI_ERR_LYLTY_POINT_INVALID: "Enter valid points.",
  UI_ERR_DEVICE_FEATURE_NOT_AVAILABLE:
    "This feature is not available for this device.",
  REST_ERR_INVALID_TEMPLATE_FIELDS: "Template invalid fields",
  REST_ERR_ACTIVE_PO_EXISTS_FOR_STORE:
    "Cannot edit levels, active PO exists for selected store",
  REST_USER_CONFIGURED_AS_PO_APPROVER:
    "Cannot delete user, user is configured as PO approver",
  REST_ERR_LEVEL_MISCONFIGURED: "PO approver level misconfigured",
  REST_ERR_APPROVERS_NOT_CONFIGURED_FOR_LEVEL: "No permitted approvers found",
  REST_ACTION_NOT_ALLOWED: "Action not allowed",
  REST_ACTIVITY_APPROVAL_NOT_APPLICABLE:
    "Approval not applicable for this activity",
  REST_APPROVAL_OBSELETE: "Activity already reviewed",
  REST_INVENTORY_ORDER_INVALID_STATE: "Approval not applicable at this point",

  //Contract Validation
  REST_INTERNAL_SUPPLIER_NOT_ALLOWED:
    "Contract with Internal Supplier is not allowed.",
  REST_CONTRACT_HAS_REFERENCES:
    "Can not delete contract as there are references to items and activivties in inventory.",
  REST_CONTRACTITEM_EDIT_NOT_ALLOWED:
    "Not permitted to update this contract item",
  REST_CONTRACT_IS_EXPIRED: "Selected Contract is Expired",
  REST_CONTRACT_ITEM_NOT_FOUND: "Contract Item not found",
  REST_CONTRACT_NOT_FOUND: "Contract is not found",
  REST_ERR_LEVELS_NOT_ALLOWED: "Levels configured are greater than threshold",
  REST_ERR_LEVELS_NOT_CONTIGOUS: "Levels configured are not contigous",
  REST_ERR_STORE_MISSING_IN_PREVIOUS_LEVELS:
    "Some stores are not configured in previous levels",
  REST_COMMISSION_CONFIG_USED_IN_AGGREGATOR:
    "Commission config is mapped with one or more Aggregator",
  REST_ERR_INVALID_COMMISSION_CONFIG_ID:
    "Commission config not present in system for given commission config Id",
  REST_NO_VALID_CONTRACT_EXISTS_FOR_SUPPLIER:
    "No Valid Contract exists for Supplier",
  REST_CONTRACT_PO_INVALID_BACKDATE_ITEMS:
    "Some Contract Items is Invalid for Selected Back Date. Please choose different date or remove items",
  REST_ERR_STATE_PENALTY_CHARGES_NOT_FOUND:
    "Please select both the state penalty charges.",
  REST_CHARGE_USED_IN_ROYALTY_CONFIG:
    "Charge can't be deleted as it is referenced in royalty config.",
  REST_ROYALTY_INVALID_CHARGES_BRANCH:
    "Charge branch is mismatch with Royalty Config branch. Please reselect branch in charge or royalty config.",
  REST_ROYALTY_INVALID_CHARGES_CHANNEL:
    "Charge channel is mismatch with Royalty Config channel. Please reselect channel in charge or royalty config.",
  REST_ROYALTY_INVALID_CHARGE: "Charge is invalid.",
  REST_ITEM_IS_STOCKED: "Cannot delete item, as item is stocked.",
  GENERAL_OPERATION_FAILED_MSG: 'Operation Failed!',
  REST_ITEM_SKU_COLUMN_MANDATORY: 'Invalid Data Format!'
};

export const pos_errormap_with_label: any = {
  // Gallary Upload
  IMAGE_BULK_UPLOAD_DONE:
    "$ images uploaded successfully. Images will take few minutes reflect on app.",

  // Upload customer:
  //upload
  REST_UPLOAD_VALIDATION_ERROR:
    "Errors found in the file uploaded. You will receive an email at $ with details.",

  // inventory backend errors
  // leave for now
  REST_SUPPLIER_INTERNAL_DUPLICATE:
    "Following branches are served by supplier shown.$Please remove them before saving.",

  // settings- backend errors
  REST_LICENCE_LIMIT_EXCEEDED: "You have exceeded your account limit of $ by $", // login
};

export const getPosErrorMessage = (code: string, args = []) => {
  let module = {
    init: function () {
      let updatedString = this.reBuildString(code, args);
      return updatedString;
    },
    reBuildString: function (code: string, args: any) {
      let string = cloneDeep(code || "").split("$"),
        newStr = "";
      for (let i = 0; i < string.length; i++) {
        newStr += string[i];
        if (args[i]) {
          newStr += args[i];
        }
      }
      return newStr;
    },
  };
  let newString = module.init();
  return newString;
};

export const getErrorMessage = (
  pos_errormap: any,
  code: string,
  ...args: any
) => {
  let newString = code;
  if (pos_errormap[code]) {
    newString = getPosErrorMessage(pos_errormap[code], args);
  }
  return newString;
};
